import React from "react";
import { Card, Button, Form, Input, notification } from "antd";
import { Auth } from "aws-amplify";

interface ICustomForgotPasswordState {
  loading: boolean;
  email: string;
}

interface ICustomForgotPasswordProps {
  onAuthChange: (state: string, e: any) => void;
  onUpdateEmail: (email: string) => void;
}

class CustomForgotPassword extends React.Component<
  ICustomForgotPasswordProps,
  ICustomForgotPasswordState
> {
  state: ICustomForgotPasswordState = {
    loading: false,
    email: ""
  };

  handleSubmit = async (e: any) => {
    e.preventDefault();
    this.setState({ loading: true });
    try {
      await Auth.forgotPassword(this.state.email.toLowerCase());
      this.props.onUpdateEmail(this.state.email.toLowerCase());
      this.props.onAuthChange("forgotPasswordVerification", {});
    } catch (e) {
      this.setState({ loading: false });
      if (e.code === "LimitExceededException") {
        notification.error({
          message: e.code,
          description: e.message
        });
      } else {
        console.log(e);
      }
    }
  };

  render() {
    const { email, loading } = this.state;
    return (
      <div className="SignIn-Container">
        <Card
          className="SignIn-Card"
          title={
            <div style={{ textAlign: "center" }}>
              <img src="/logo-ketrics.png" alt="" width="300" />
            </div>
          }
        >
          <Form layout="vertical">
            <Form.Item label="Email">
              <Input
                size="large"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                onPressEnter={this.handleSubmit}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                style={{ width: "100%" }}
                onClick={this.handleSubmit}
                loading={loading}
                disabled={loading}
              >
                Submit
              </Button>
            </Form.Item>

            <div style={{ textAlign: "left" }}>
              <Button
                type="link"
                size="large"
                onClick={() => this.props.onAuthChange("signIn", {})}
              >
                Back to Sign In
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    );
  }
}

export default CustomForgotPassword;
